import { inject, injectable } from "inversify";

import ListViewModel from "@vm/List/ListViewModel";
import BalanceGroup from "@model/BalanceGroup";
import TYPES from "../../inversify.types";
// There is error in babel
// remove this after https://github.com/babel/babel/issues/9838
// will be fixed
void TYPES;
void inject;

@injectable()
export default class BalanceGroupListVM extends ListViewModel<BalanceGroup, Repository<BalanceGroup>> {
  constructor(@inject(TYPES.BalanceGroupRepository) repository: Repository<BalanceGroup>) {
    super(repository);
  }
}
